import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { ButtonTypeTokens, ButtonWidthTypeToken, FontFamilyTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, WIDGET, StackType, StackAlignItems, StackJustifyContent, IconTokens, IconAlignmentTokens, IconSizeTokens, FontSizeTokens, ColorTokens, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { updateSliderAmount, sliderAmountOnChange, getEditAmountOnLoad, goBack } from "./actions";
import { isDarkModeTheme } from "../../../configs/config";
import { heightMap } from "../../../configs/height";
import sharedPropsService from "../../../SharedPropsService";
import SharedPropsService from "../../../SharedPropsService";
import { addCommasToNumber, allowDynamicLimitFromBE } from "../../../configs/utils";
let isDarkMode = isDarkModeTheme();
export const template = (maxAmount, stepResponseObject, updateAvailableCASMap, user, minimumAmount, allowDynamicLimitFromBEFlag) => ({
    layout: {
        id: ROUTE.UPDATE_SLIDER_AMOUNT,
        type: LAYOUTS.MODAL,
        style: {
            height: heightMap[ROUTE.UPDATE_SLIDER_AMOUNT]
        },
        widgets: [
            {
                id: 'headerStack',
                type: WIDGET.STACK,
            },
            { id: "space1", type: WIDGET.SPACE },
            { id: "input", type: WIDGET.INPUT },
            { id: "space4", type: WIDGET.SPACE },
            {
                id: "continue",
                type: WIDGET.BUTTON,
                position: POSITION.FIXED_BOTTOM,
            },
        ],
    },
    datastore: {
        space0: { size: SizeTypeTokens.XXXXL },
        headerStack: {
            type: StackType.row,
            alignItems: StackAlignItems.flexEnd,
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: "title", type: WIDGET.TEXT },
                { id: 'leadIcon', type: WIDGET.BUTTON },
            ],
        },
        leadIcon: {
            id: 'bt_setCreditLimit_cancel',
            label: '',
            type: ButtonTypeTokens.SmallGhost,
            width: ButtonWidthTypeToken.CONTENT,
            stack: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
            },
            labelColor: ColorTokens.Grey_Night,
            icon: {
                name: IconTokens.Cross,
                align: IconAlignmentTokens.right,
                size: IconSizeTokens.XXL,
            },
            action: {
                type: ACTION.GO_BACK,
                payload: {},
                routeId: ROUTE.UPDATE_SLIDER_AMOUNT,
            },
        },
        title: {
            label: `Select the credit limit amount`,
            fontSize: FontSizeTokens.MD,
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: '600',
            // textAlign: TextAlignTokens.center,
            lineHeight: 24,
        },
        continue: {
            id: 'bt_setCreditLimit_confirm',
            label: "Confirm",
            fontFamily: FontFamilyTokens.Inter,
            type: ButtonTypeTokens.LargeFilled,
            fontSize: FontSizeTokens.SM,
            width: ButtonWidthTypeToken.FULL,
            action: {
                type: ACTION.EDIT_SLIDER_AMOUNT,
                payload: {
                    value: "",
                    maxAmount,
                    stepResponseObject,
                    updateAvailableCASMap,
                },
                routeId: ROUTE.UPDATE_SLIDER_AMOUNT,
            },
        },
        input: {
            id: 'tf_setCreditLimit_creditLimit',
            type: InputTypeToken.DEFAULT,
            state: InputStateToken.DEFAULT,
            title: "Credit limit",
            isDarkMode: isDarkMode ? true : false,
            onlyNumeric: true,
            placeholder: "Enter credit limit",
            keyboardType: KeyboardTypeToken.numberPad,
            caption: {
                error: allowDynamicLimitFromBEFlag ? `Minimum credit limit allowed is ₹${minimumAmount && addCommasToNumber(minimumAmount)}` : 'Minimum credit limit allowed is ₹25,000'
            },
            action: {
                type: ACTION.SLIDER_AMOUNT_ONCHANGE,
                payload: {
                    value: '',
                    maxAmount: maxAmount,
                    targetWidgetId: "continue",
                    user: user
                },
                routeId: ROUTE.UPDATE_SLIDER_AMOUNT,
            },
            // caption: { error: "Enter a valid amount" },
            // errorAction: {
            //   type: ACTION.DISABLE_CONTINUE,
            //   routeId: ROUTE.UPDATE_SLIDER_AMOUNT,
            //   payload: { targetWidgetId: "continue", minAmount: 25000 },
            // },
            // successAction: {
            //   type: ACTION.ENABLE_CONTINUE,
            //   routeId: ROUTE.UPDATE_SLIDER_AMOUNT,
            //   payload: { targetWidgetId: "continue", minAmount: 25000 },
            // },
        },
        space1: { size: SizeTypeTokens.SM },
        space3: { size: SizeTypeTokens.MD },
        space4: { size: SizeTypeTokens.XXL },
    },
});
export const updateSliderAmountMF = {
    onLoad: async ({ instrumentTrack }, { maxAmount, stepResponseObject, updateAvailableCASMap }) => {
        const allowDynamicLimitFromBEFlag = await allowDynamicLimitFromBE();
        // const prevMob = `${(
        //   await SharedPropsService.getUser()
        // ).linkedBorrowerAccounts[0].accountHolderPhoneNumber.replace("+91", "")}`;
        instrumentTrack("EDIT_AMOUNT_BUTTON_CLICKED");
        const user = await sharedPropsService.getUser();
        const minimumEligibleLimit = await SharedPropsService.getMinimumEligibleLimitData();
        //@ts-ignore
        const isEligible = minimumEligibleLimit?.isEligible;
        //@ts-ignore
        const minimumAmount = minimumEligibleLimit?.amount;
        return Promise.resolve(template(maxAmount, stepResponseObject, updateAvailableCASMap, user, minimumAmount, allowDynamicLimitFromBEFlag));
    },
    actions: {
        [ACTION.EDIT_SLIDER_AMOUNT]: updateSliderAmount,
        [ACTION.SLIDER_AMOUNT_ONCHANGE]: sliderAmountOnChange,
        [ACTION.GET_EDIT_AMOUNT_ONLOAD]: getEditAmountOnLoad,
        [ACTION.GO_BACK]: goBack,
        //[ACTION.ENABLE_CONTINUE]: toggleCTA,
        //[ACTION.DISABLE_CONTINUE]: toggleCTA,
    },
    action: {
        type: ACTION.GET_EDIT_AMOUNT_ONLOAD,
        payload: {},
        routeId: ROUTE.UPDATE_SLIDER_AMOUNT
    }
};
